const translateFieldHeader = (field) => {
  switch (field) {
    case 'First Name': return "Vorname";
    case 'Last Name': return "Nachname";
    case 'Broker Name': return "Maklername";
    case 'Phone Number': return "Telefonnummer";
    case 'Zip Code': return "PLZ";
    case 'Zip Codes': return "PLZ";
    case 'Responsibility Area': return "Verantwortungsbereich";
    case 'Points': return "Punkte";
    case 'Province': return "Bezirk";
    case 'Estimations Number': return "Schätzungszahl";
    case 'Estimations Average': return "Durchschnitt";
    case 'Place': return "Platz";
    case 'Region Place': return "Regionsplatz";
    case 'Type': return "Typ";
    case 'Size': return "Größez";
    case 'Address': return "Adresse";
    case 'Rooms': return "Räume";
    case 'Floor': return "Umhauen";
    case 'Extras': return "Extras";
    case 'Is Agreed': return "Ist vereinbart";
    case 'Is Estimated': return "Wird geschätzt";
    case 'Price': return "Preis";
    case 'Sub Category': return "Unterkategorie";
    case 'Living Surface': return "Wohnfläche";
    case 'Year Of Built': return "Baujahr";
    case 'Has Basement': return "Keller";
    case 'Floors': return "Etagen";
    case 'Condition Rate': return "Konditionsrate";
    case 'Intention To Sell': return "Absicht zu verkaufen";
    case 'City': return "Stadt";
    case 'House Number': return "Hausnummer";
    case 'Has Balcony': return "Balkon";
    case 'Has Loggia': return "Loggia";
    case 'Has Garden': return "Garten";
    case 'Has Carport': return "Carport";
    case 'Has Garage': return "Garage";
    case 'Has Parking': return "Parkplätze";
    case 'Has Basement Closet': return "Kellerschrank";
    case 'Has Energy Certificate': return "Energieausweis";
    case 'Heating System': return "Heizungssystem";
    case 'Is Open Offer': return "Ist offenes Angebot";
    case 'Monthly Costs': return "Monatliche Kosten";
    case 'Heating Costs': return "HWB";
    case 'Photos': return "Fotos";
    case 'Displayed To Broker': return "Dem Broker angezeigt";
    case 'Company Name': return "Name der Firma";
    case 'Houses Estimated': return "Bewertete Häuser";
    case 'Apartment Estimated': return "Bewertete Wohnungen";
    case 'Parcel Estimated': return "Bewertete Grundstücke";
    case 'Average Property Price': return "Durchschnittspreis";
    case 'Intention To Sell10': return "Verkaufsbereitschaft 10";
    case 'Intention To Sell9': return "Verkaufsbereitschaft 9";
    case 'Intention To Sell8': return "Verkaufsbereitschaft 8";
    case 'Intention To Sell7': return "Verkaufsbereitschaft 7";
    case 'Intention To Sell6': return "Verkaufsbereitschaft 6";
    case 'Intention To Sell5': return "Verkaufsbereitschaft 5";
    case 'Intention To Sell4': return "Verkaufsbereitschaft 4";
    case 'Intention To Sell3': return "Verkaufsbereitschaft 3";
    case 'Intention To Sell2': return "Verkaufsbereitschaft 2";
    case 'Intention To Sell1': return "Verkaufsbereitschaft 1";
    case 'Can Customers': return "Benutzer bearbeiten";
    case 'Can Brokers': return "Makler bearbeiten";
    case 'Can Statistics': return "Statistiken ansehen";
    case 'Can Ranking': return "Ranking-Übersicht";
    case 'Can Messages': return "Nachrichten lesen";
    case 'Can Notifications': return "Angebote senden";
    case 'Can Partner': return "Partner bearbeiten";
    case 'Phone Number Confirmed': return "Rufnummer bestätigt";
    case 'Is Open Offert': return "In Arbeit";
    case "Is Closed": return "Wird verweigert";
    case "Has Met": return "Hat getroffen";
    case "Has Contract": return "Hat Vertrag";
    case "Created Date": return "Erstellt am";

    default: return field;
  }
};

export default translateFieldHeader;